import React from 'react';

export const TicketDetailsSkeleton: React.FC = () => (
  <div
    className="flex flex-col gap-6 relative p-6 animate-pulse"
    data-testid="ticket-details-skeleton"
  >
    {/* Header Skeleton */}
    <div className="flex justify-between items-start">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 bg-gray-200 rounded-full shrink-0" />
        <div className="flex flex-col gap-2">
          <div className="h-4 w-44 bg-gray-200 rounded-md" />
          <div className="h-3 w-32 bg-gray-100 rounded-md" />
        </div>
      </div>
      <div className="h-6 w-16 bg-gray-200 rounded-full" />
    </div>

    {/* Title & Description Skeleton */}
    <div className="flex flex-col gap-2">
      <div className="h-7 w-52 bg-gray-200 rounded-md" />
      <div className="h-4 w-72 bg-gray-100 rounded-md mb-2" />
      <div className="flex flex-col gap-2">
        <div className="h-4 w-full bg-gray-100 rounded-md" />
        <div className="h-4 w-11/12 bg-gray-100 rounded-md" />
        <div className="h-4 w-4/5 bg-gray-100 rounded-md" />
      </div>
    </div>

    {/* Attachment Skeleton */}
    <div>
      <div className="h-5 w-28 bg-gray-200 rounded-md mb-3" />
      <div className="flex items-center justify-between border border-[#E5E7EB] rounded-2xl p-4">
        <div className="flex items-center gap-3.5">
          <div className="w-12 h-12 bg-gray-100 rounded-xl" />
          <div className="flex flex-col gap-2">
            <div className="h-4 w-48 bg-gray-200 rounded-md" />
            <div className="h-3 w-28 bg-gray-100 rounded-md" />
          </div>
        </div>
        <div className="flex gap-2.5">
          <div className="w-9 h-9 rounded-full bg-gray-100" />
          <div className="w-9 h-9 rounded-full bg-gray-100" />
        </div>
      </div>
    </div>

    {/* Activity section Skeleton */}
    <div className="bg-gray-50/70 border border-gray-100 rounded-2xl p-6">
      <div className="h-5 w-32 bg-gray-200 rounded-md mb-6" />
      <div className="flex flex-col items-center justify-center py-6 gap-3">
        <div className="w-20 h-20 bg-gray-200/60 rounded-xl" />
        <div className="h-4 w-48 bg-gray-200 rounded-md" />
        <div className="h-3 w-64 bg-gray-100 rounded-md" />
      </div>
    </div>

    {/* History section Skeleton */}
    <div>
      <div className="h-6 w-36 bg-gray-200 rounded-md mb-4" />
      <div className="border border-gray-100 rounded-xl p-4 flex justify-between items-center">
        <div className="flex flex-col gap-2">
          <div className="h-4 w-40 bg-gray-200 rounded" />
          <div className="h-3 w-56 bg-gray-100 rounded" />
        </div>
        <div className="h-6 w-20 bg-gray-100 rounded-full" />
      </div>
    </div>
  </div>
);

export default TicketDetailsSkeleton;
